export const categories = {
  home: 'домашняя школа',
  ege: 'егэ',
  oge: 'огэ',
  external: 'экстернат',
  full: 'экзамен на 100 баллов',
};

export const cards = [
  {
    id: 3,
    cardTitle: 'Курсы ЕГЭ',
    cardSubtitle: '4 в 1',
    categories: [categories.ege, categories.full],
    cardImage: '/v2/black-friday-24/cards/card3.webp',
    saleSizes: ['— 56%'],
    saleColor: '#FF5319',
    // eslint-disable-next-line max-len,vue/max-len
    cardText: 'Подготовьтесь к ЕГЭ с выгодой и уверенностью: скидка 56% на пакет из четырех курсов!',
    cardPrice: {
      perMonth: true,
      price: '1 569',
      oldPrice: '3 566',
      priceDescription: 'при рассрочке на 12 месяцев',
    },
    modalTitle: 'Поступайте на курсы ЕГЭ 4 в 1',
    btnText: 'поступить на курсы',
  },
  {
    id: 8,
    cardTitle: 'Домашняя школа',
    cardSubtitle: 'тариф комфорт',
    categories: [categories.home],
    cardImage: '/v2/black-friday-24/cards/card8.webp',
    sticker: '/v2/black-friday-24/cards/gift15-sticker.png',
    saleSizes: ['— 20%', '— 50% на ЕГЭ/ОГЭ'],
    saleColor: '#8D176C',
    // eslint-disable-next-line max-len,vue/max-len
    cardText: 'Персонализированное обучение. Доступ к знаниям через интерактивные вебинары и поддержку экспертов',
    cardPrice: {
      perMonth: true,
      price: '4 375',
      oldPrice: '6 250',
      priceDescription: 'при рассрочке на 24 месяца',
    },
    modalTitle: 'поступайте в домашнюю школу на «комфорт»',
    btnText: 'поступить в школу',
  },
  {
    id: 5,
    cardTitle: 'Экстернат',
    cardSubtitle: 'для детей',
    categories: [categories.external],
    cardImage: '/v2/black-friday-24/cards/card5.webp',
    saleSizes: ['— 60%'],
    saleColor: '#FF5319',
    // eslint-disable-next-line max-len,vue/max-len
    cardText: 'Удобно и быстро: учись из дома и заканчивай школу вдвое быстрее! Создай своё расписание сам',
    cardPrice: {
      perMonth: true,
      price: '5 983',
      oldPrice: '12 250',
      priceDescription: 'при рассрочке на 24 месяца',
    },
    modalTitle: 'Поступайте на курс экстернат для детей',
    btnText: 'поступить на экстернат',
  },
  {
    id: 6,
    cardTitle: 'Экстернат',
    cardSubtitle: 'для взрослых',
    categories: [categories.external],
    cardImage: '/v2/black-friday-24/cards/card7.webp',
    saleSizes: ['— 60%'],
    saleColor: '#FF5319',
    // eslint-disable-next-line max-len,vue/max-len
    cardText: 'Откройте новые возможности. Закончите школу и получите аттестат без отрыва от работы или дома!',
    cardPrice: {
      perMonth: true,
      price: '5 983',
      oldPrice: '12 250',
      priceDescription: 'при рассрочке на 24 месяца',
    },
    modalTitle: 'Поступайте на курс экстернат с подготовкой',
    btnText: 'поступить на экстернат',
  },
  {
    id: 1,
    cardTitle: 'Курсы ОГЭ',
    cardSubtitle: '4 в 1',
    categories: [categories.oge, categories.full],
    cardImage: '/v2/black-friday-24/cards/card1.webp',
    saleSizes: ['— 56%'],
    saleColor: '#FF5319',
    // eslint-disable-next-line max-len,vue/max-len
    cardText: 'Подготовьтесь к ОГЭ с выгодой и уверенностью: скидка 56% на пакет из четырех курсов!',
    cardPrice: {
      perMonth: true,
      price: '1 569',
      oldPrice: '3 566',
      priceDescription: 'при рассрочке на 12 месяцев',
    },
    modalTitle: 'Поступайте на курсы ОГЭ 4 в 1',
    btnText: 'поступить на курсы',
  },
  {
    id: 4,
    cardTitle: 'Курс ЕГЭ',
    cardSubtitle: 'по 1 предмету',
    categories: [categories.ege, categories.full],
    cardImage: '/v2/black-friday-24/cards/card4.webp',
    sticker: '/v2/black-friday-24/cards/gift-sticker.png',
    saleSizes: [],
    // eslint-disable-next-line max-len,vue/max-len
    cardText: 'Детальный разбор заданий ЕГЭ, доступ к уникальным материалам, подготовка на 85+ баллов, в подарок курс по Итоговому сочинению',
    cardPrice: {
      perMonth: true,
      price: '3 299',
      oldPrice: null,
      priceDescription: 'при рассрочке на 12 месяцев',
    },
    modalTitle: 'Поступайте на курс ЕГЭ по 1 предмету',
    btnText: 'поступить на курсы',
  },
  {
    id: 9,
    cardTitle: 'Домашняя школа',
    cardSubtitle: 'тариф премиум',
    categories: [categories.home],
    cardImage: '/v2/black-friday-24/cards/card9.webp',
    sticker: '/v2/black-friday-24/cards/gift15-sticker.png',
    saleSizes: ['— 30%', '— 50% на ЕГЭ/ОГЭ'],
    saleColor: '#FF5319',
    // eslint-disable-next-line max-len,vue/max-len
    cardText: 'Тариф «Премиум» в домашней школе, подготовка к ЕГЭ и ОГЭ с личными наставниками и углублённым подходом к каждому предмету.',
    cardPrice: {
      perMonth: true,
      price: '11 388',
      oldPrice: '16 257',
      priceDescription: 'при рассрочке на 24 месяца',
    },
    modalTitle: 'поступайте в домашнюю школу на «премиум»',
    btnText: 'поступить в школу',
  },
  {
    id: 2,
    cardTitle: 'Курс ОГЭ',
    cardSubtitle: 'по 1 предмету',
    categories: [categories.oge, categories.full],
    cardImage: '/v2/black-friday-24/cards/card2.webp',
    sticker: '/v2/black-friday-24/cards/gift-sticker.png',
    saleSizes: [],
    // eslint-disable-next-line max-len,vue/max-len
    cardText: 'Детальный разбор заданий ОГЭ, подготовка на 85+ баллов, в подарок курс по Итоговому собеседованию',
    cardPrice: {
      perMonth: true,
      price: '3 299',
      oldPrice: null,
      priceDescription: 'при рассрочке на 12 месяцев',
    },
    modalTitle: 'Поступайте на курс ОГЭ по 1 предмету',
    btnText: 'поступить на курсы',
  },
];

export default { categories, cards };
